import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../store/store';
import { UserRole } from '../../types/common';
import { Box, CircularProgress } from '@mui/material';

interface ProtectedRouteProps {
    allowedRoles?: UserRole[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles }) => {
    // We use 'token' as the source of truth for "Is Logged In?"
    const { user, token } = useAppSelector((state) => state.auth);
    const location = useLocation();


    // 1. Not Logged In? -> Go to Login
    if (!token) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // 2. Logged In, but User Profile not loaded yet? 
    // (This usually handled by 'loading', but as a safeguard keep spinner)
    if (!user) {
         return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    // 3. Check Role Access
    if (allowedRoles && !allowedRoles.includes(user.role)) {
        // Unauthorized Role -> Redirect to their specific dashboard
        if (user.role === UserRole.ADMIN) {
            return <Navigate to="/admin/dashboard" replace />;
        } else if (user.role === UserRole.DOCTOR) {
            return <Navigate to="/doctor/dashboard" replace />;
        } else if (user.role === UserRole.PATIENT) {
            return <Navigate to="/patient/dashboard" replace />;
        }
        return <Navigate to="/" replace />;
    }

    // 5. Allowed -> Render Page
    return <Outlet />;
};

export default ProtectedRoute;